import {Transformer} from '../Transformer';

class JsonTransformer extends Transformer {
    transform(data) {
        return JSON.stringify(data);
    }
}

export {JsonTransformer};
